import clsx from 'clsx';
import React from 'react';
import { useParams } from 'react-router';

import { ICONS } from '@/src/components/common/Elements/Icon/Icon';
import Spinner from '@/src/components/common/Elements/Spinner/Spinner';
import { isResponseError } from '@/src/components/project/Inbox2/api/config';
import ActionButton from '@/src/components/project/Inbox2/Elements/ActionButton/ActionButton';
import { useInboxEntryPanel } from '@/src/components/project/Inbox2/store/inboxEntryPanel.store';
import { FileEntry } from '@/src/components/project/Inbox2/types';
import { showToast } from '@/src/globalFunction';

import { useValidateActionResponse } from '../../../../useValidateActionResponse';
import { useMarkDeleteFile } from '../../../api/markDeleteFile';

type RestoreFileProps = {
  fileEntry: FileEntry;
  enabled: boolean;
};

const RestoreFile = ({ fileEntry, enabled = true }: RestoreFileProps) => {
  const { setInboxEntry } = useInboxEntryPanel();
  const { projectId } = useParams<{ projectId: string }>();
  const restoreFileMutation = useMarkDeleteFile({
    projectId,
    sourceFileId: fileEntry.id,
    trash: false,
  });
  const { confirmRefreshModal } = useValidateActionResponse({
    responseError: isResponseError(restoreFileMutation.data) ? restoreFileMutation.data : null,
  });

  const handleClick = async () => {
    const response = await restoreFileMutation.mutateAsync({
      fileId: fileEntry.id,
      trash: false,
    });

    if (response) {
      setInboxEntry(null);
      showToast('success', 'Successfully restored the entry.');
    }
  };

  return (
    <div className="menu-content">
      {restoreFileMutation.isLoading && <Spinner />}
      <ActionButton
        id={'restore_file'}
        className={clsx('')}
        icon={ICONS.restore}
        iconClasses={clsx('')}
        onClick={handleClick}
        tooltipSettings={{
          content: 'Restore',
          place: 'left',
        }}
        disabled={!enabled}
      />
      {confirmRefreshModal}
    </div>
  );
};

export default RestoreFile;
